import React from 'react';

const BrandsCarousel = () => {
  // Common car brands that auto repair shops service
  const carBrands = [
    'Acura', 'Audi', 'BMW', 'Buick', 'Cadillac', 'Chevrolet',
    'Chrysler', 'Dodge', 'Ford', 'GMC', 'Honda', 'Hyundai',
    'Infiniti', 'Jeep', 'Kia', 'Lexus', 'Mazda', 'Mercedes-Benz',
    'Nissan', 'Porsche', 'Ram', 'Subaru', 'Tesla', 'Toyota',
    'Volkswagen', 'Volvo'
  ];

  return (
    <section className="py-16 bg-[#0f0f0f] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            We Service All Makes & Models
          </h2>
          <p className="text-gray-400 text-lg">
            Expert repairs for domestic, import, and luxury vehicles
          </p>
        </div>
      </div>

      {/* Scrolling Carousel */}
      <div className="relative">
        <div className="flex overflow-hidden">
          <div className="flex animate-scroll">
            {carBrands.concat(carBrands).map((brand, index) => (
              <div
                key={`${brand}-${index}`}
                className="flex-shrink-0 mx-6 w-32 h-24 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg flex items-center justify-center hover:bg-white/10 hover:border-[#ff6b35]/30 transition-all duration-300"
              >
                <span className="text-white font-semibold text-sm text-center px-2">
                  {brand}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsCarousel;
